/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material'
/* Imports */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

am4core.addLicense("CH208466903");


const JobTypeChart = (props) => {

    const { sBA, data } = props

    useEffect(() => {
        if (data && data.length > 0) {
            data.forEach(itemHead => {
                if (itemHead.lstGraph.length > 0) {
                    itemHead.lstGraph.forEach(itemChild => {
                        onRenderGraphStackBar(itemChild.lstData, itemChild.sId, itemHead.sId, itemChild.nMaxScore, itemChild.sQuestionair, itemHead.sTitle);
                    });
                }
            });
        }
    }, [data])

    const onRenderGraphStackBar = (data, index, nJobType, nMaxScore, sTitle, itemHeadTitle) => {
        let chart = am4core.create(`bar-jobtype${nJobType}_${index}`, am4charts.XYChart);

        let title = chart.titles.create();
        title.text = sTitle;
        title.fontSize = 16;
        title.marginBottom = 0;
        title.align = "left";
        title.fontWeight = '400';

        // Add data
        chart.data = data;

        // Create axes
        let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "name";
        categoryAxis.renderer.grid.template.opacity = 0;

        let valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
        valueAxis.min = 0;
        valueAxis.max = nMaxScore;
        valueAxis.strictMinMax = true;
        valueAxis.renderer.grid.template.opacity = 0;
        valueAxis.renderer.ticks.template.strokeOpacity = 0.5;
        valueAxis.renderer.ticks.template.stroke = am4core.color("#495C43");
        valueAxis.renderer.ticks.template.length = 10;
        valueAxis.renderer.line.strokeOpacity = 0.5;
        valueAxis.renderer.baseGrid.disabled = true;
        valueAxis.renderer.minGridDistance = 40;

        // Create series
        function createSeries(field, name) {
            let series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.valueX = field;
            series.dataFields.categoryY = "name";
            series.name = name;
            series.columns.template.tooltipText = "{categoryY}: {valueX}";

        }
        createSeries("value", "Value");

        let idx = parseInt(index) ?? 0;

        setTimeout(() => {
            chart.exporting.getImage("png").then((data) => {
                let obj = {
                    id: idx,
                    nOrder: idx + 1,
                    sDesc: "Div 3 job bar 6",
                    sName: itemHeadTitle,
                    idDiv: 3,
                    imgBase64: data
                }
                props.exportImg && props.exportImg(obj);
            });
        }, 2000);
    }


    return (
        <>
            <div className='div-border'>
                <Grid container spacing={1} direction="row" justifyContent="center" alignItems="start" >.
                    <Grid item xs={12}>
                        <Typography style={{ fontWeight: 500 }}>กลุ่มตลาด: {sBA}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <div id='SatisFactiondiv3' style={{ padding: '8px' }}>
                            <Grid container spacing={1} direction="row" justifyContent="center" alignItems="start" >
                                {
                                    data && data.length > 0 ?
                                        <>
                                            {
                                                data.map((itemHead, index) => {
                                                    return (
                                                        <Fragment key={`g-head-jobtype_${index}`}>
                                                            <Grid item xs={12} sm={6} style={{ borderRight: index == 0 && data.length == 2 ? '1px solid #d4d4d4' : '', color: index == 0 ? '#d4d4d4' : '' }}>
                                                                <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center" >
                                                                    <Grid item xs={12} style={{ textAlign: "center" }}>
                                                                        <Typography style={{ color: '#000000' }}><b>{itemHead.sTitle}</b></Typography>
                                                                    </Grid>
                                                                    {
                                                                        itemHead.lstGraph.length > 0 ?
                                                                            itemHead.lstGraph.map((itemChild, index) => {
                                                                                return (
                                                                                    <Fragment key={`g-child-jobtype${itemHead.sId}_${index}`} >
                                                                                        {/* <Grid item xs={12} style={{ color: '#000000' }}>
                                                                                            <Typography>{itemChild.sQuestionair}</Typography>
                                                                                        </Grid> */}
                                                                                        <Grid item xs={12}>
                                                                                            <div id={`bar-jobtype${itemHead.sId}_${index + 1}`} style={{ width: "100%", height: "120px" }}></div>
                                                                                        </Grid>
                                                                                    </Fragment>
                                                                                )
                                                                            })
                                                                            : null
                                                                    }
                                                                </Grid>
                                                            </Grid>
                                                        </Fragment>

                                                    )
                                                })
                                            }
                                        </>
                                        :
                                        null
                                }
                            </Grid>
                        </div>

                    </Grid>
                </Grid>
            </div>
        </>
    )
}

export default JobTypeChart